import request from '../common/request.js';


//新增应用类型
export function AddAppCategory(payload) {
    return request.post('/app/AddAppCategory', payload);
}

//获取应用类型列表
export function GetAppCategoryList(payload) {
    return request.post('/app/GetAppCategoryList', payload);
}


//更新应用类型
export function UpdateAppCategory(payload) {
    return request.post('/app/UpdateAppCategory', payload);
}

//删除应用类型
export function DeleteAppCategory(payload) {
    return request.get('/app/DeleteAppCategory', payload);
}

//修改设备授权应用分类
export function UpdateDeviceAppCategory(payload) {
    return request.get('/app/UpdateDeviceAppCategory', payload);
}
